
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40.102 10.85l.012 1.935c.536.367.886.976.886 1.665v.38c0 .768-.436 1.437-1.078 1.782.18.898.23 1.818.152 2.734a9.726 9.726 0 01-1.094 3.707 9.931 9.931 0 01-2.46 3.016 10.178 10.178 0 01-3.454 1.865 10.323 10.323 0 01-7.71-.639 10.075 10.075 0 01-3.083-2.407 9.828 9.828 0 01-1.906-3.374 9.468 9.468 0 01-.296-4.905A2.025 2.025 0 0119 14.83v-.38c0-.687.349-1.294.882-1.662V10.85a6.38 6.38 0 011.932-4.562A6.67 6.67 0 0126.477 4.4h7.03c1.75 0 3.427.68 4.664 1.89a6.38 6.38 0 011.931 4.558v.003zm-16.79-3.094a4.527 4.527 0 013.165-1.283h7.03c1.188 0 2.326.462 3.165 1.283a4.33 4.33 0 011.31 3.095v.005l.01 1.562h-15.99v-1.567a4.33 4.33 0 011.31-3.095zm15.568 6.736H21.12v.297h17.76v-.297zm-16.697 2.37H37.81a7.65 7.65 0 01-.713 5.239 7.85 7.85 0 01-1.945 2.383 8.041 8.041 0 01-2.729 1.474 8.16 8.16 0 01-6.094-.505 7.964 7.964 0 01-2.436-1.902 7.769 7.769 0 01-1.507-2.67l-.003-.008a7.438 7.438 0 01-.2-4.01zM40.654 52.131H19.267c-2.37 0-4.3-1.931-4.31-4.28v-3.634c0-.19.02-.389.07-.598.66-7.656 7.21-13.64 14.928-13.64 7.719 0 14.268 5.984 14.928 13.64.05.2.07.398.07.598v3.633c0 2.36-1.93 4.281-4.3 4.281zm-23.657-8.133c-.02.08-.03.149-.03.209h.02v3.633c0 1.265 1.03 2.29 2.3 2.29h21.386c1.27 0 2.3-1.025 2.3-2.29v-3.633c0-.06-.01-.13-.03-.21l-.03-.149c-.55-6.66-6.239-11.877-12.948-11.877-6.709 0-12.398 5.217-12.938 11.877l-.03.15z"}})])
          )
        }
      }
    